import { render, staticRenderFns } from "./ClientesConSuscripcion.vue?vue&type=template&id=470bc1a8"
import script from "./ClientesConSuscripcion.vue?vue&type=script&lang=js"
export * from "./ClientesConSuscripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports